export { default as ProductsStylesFilterBadge } from './ProductsStylesFilterBadge';
